<script>
import RawData from "@/components/widgets/raw-data.vue";

export default {
    name: 'PoObligationList',
    components: {
        RawData,
    },
    props: {
        type: {
            type: String,
            default: 'pending'
        },
        items: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: 'Obligation List',
        },
        subtitle: {
            type: String,
            default: 'List of Obligations',
        },
        loading: Boolean
    },
    data() {
        return {
            currentPage: 1,
            perPage: 10,
            filter: '',
            pageOptions: [10, 20, 50, 100]
        };
    },
    computed: {
        filtered(){
            let data = this.items;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            if (this.filter.trim() != "" && this.filter) {
                return this.filtered.length;
            } else {
                return this.items.length;
            }
        }
    },
    methods: {
        requestRFP(item) {
            this.$emit('requestRFP', item);
        },
        printPO(id) {
            this.$emit('printPO', id);
        },
        getAttachments(item) {
            this.$emit('getAttachments', item);
        },
    },
}
</script>
<template>
    <div>
        <div class="row mb-2">
            <div class="col-md-6">
                <h5 class="mb-0">{{title}}</h5>
                <div>
                    <small class="cursor-pointer">{{subtitle}}</small>
                </div>
            </div>
            <div class="col-md-6 text-right">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter me-1"
                >
                    <label class="d-inline-flex align-items-center">
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search Items..."
                            class="form-control me-1"
                        ></b-form-input>
                        <b-form-select
                            class="form-select w-25"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <template v-if="loading">
                    <div class="text-center mt-5 pt-5">
                        <b-spinner
                            variant="primary"
                            label="Loading..."
                        ></b-spinner>
                    </div>
                </template>
                <template v-else>
                    <template v-if="items.length == 0">
                        <div class="text-center mt-5 pt-5">
                            <h5>No Data Found.</h5>
                        </div>
                    </template>
                    <template v-else>
                        <div role="tablist" v-for="x in filtered" :key="x.id">
                            <b-card no-body class="mb-1 shadow-none position-relative">
                                <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                                <b-card-header header-tag="header" role="tab">
                                    <div
                                        class="
                                            d-flex
                                            justify-content-between
                                            align-items-center
                                        "
                                    >
                                        <div>
                                            <span v-if="type != 'pending'" class="font-weight-bold text-white" title="RFP Number">{{x.rfpNumber}} : </span><span title="P.O Number">{{ x.poNumber }}</span>
                                            <h4 class="mb-0">{{ type != 'pending' ? x.particulars : x.description }}</h4>
                                            <small>{{ type != 'pending' ? x.supplier : x.supplierName }}&nbsp;
                                                [<a
                                                    href="javascript:void(0);"
                                                    @click="x.visible = !x.visible"
                                                >
                                                    {{ x.visible ? "Hide" : "Show More" }} Details
                                                </a>]
                                            </small>
                                        </div>
                                        <div class="d-flex align-items-center" v-if="type == 'pending'">
                                            <button type="button" class="btn btn-outline-success" @click="requestRFP(x)"><i class="bx bx-edit"></i> Request for Obligation</button>
                                        </div>
                                    </div>
                                </b-card-header>
                                <b-collapse
                                    :visible="x.visible"
                                    :accordion="`pending-accordion-${x.id}`"
                                    role="tabpanel"
                                >
                                    <b-card-body>
                                        <div class="row" v-if="type == 'pending'">
                                            <div class="col-md-5">
                                                <b class="font-size-16"
                                                    >Supplier Details:</b
                                                >
                                                <div class="d-flex ms-4 mt-2">
                                                    <i class="me-2">-</i
                                                    ><span class="font-size-14"
                                                        >Name:
                                                        {{
                                                            x.supplierName
                                                        }}</span
                                                    >
                                                </div>
                                                <div class="d-flex ms-4">
                                                    <i class="me-2">-</i
                                                    ><span class="font-size-14"
                                                        >Address:
                                                        {{
                                                            x.supplierAddress
                                                        }}</span
                                                    >
                                                </div>
                                                <div class="d-flex ms-4">
                                                    <i class="me-2">-</i
                                                    ><span class="font-size-14"
                                                        >Contact No.:
                                                        {{
                                                            x.supplierContactNumber
                                                        }}</span
                                                    >
                                                </div>
                                                <div class="d-flex ms-4">
                                                    <i class="me-2">-</i
                                                    ><span class="font-size-14"
                                                        >Email:
                                                        <a href="javascript:void(0);">{{
                                                            x.supplierEmailAddress
                                                        }}</a></span
                                                    >
                                                </div>
                                                <div
                                                    class="d-flex ms-4"
                                                    v-if="x.rfqSupplierNote"
                                                >
                                                    <i class="me-2">-</i
                                                    ><span class="font-size-14"
                                                        >Note:
                                                        {{
                                                            x.rfqSupplierNote
                                                        }}</span
                                                    >
                                                </div>
                                                <div class="mt-2">
                                                    <div class="d-flex align-items-center">
                                                        <b class="font-size-16 me-2">PR No:</b>
                                                        <span class="text-warning font-size-15">{{ x.prNumber }}</span>
                                                    </div>
                                                </div>
                                                <div
                                                    class="
                                                        mt-2
                                                        d-flex
                                                        align-items-center
                                                    "
                                                >
                                                    <b class="font-size-16"
                                                        ><i class="bx bx-paperclip"></i
                                                        >Attachments</b
                                                    >
                                                    <a
                                                        href="javascript:void(0);"
                                                        class="ms-1"
                                                        @click="getAttachments(x)"
                                                        :id="`viewFiles-${x.id}`"
                                                        >[Show attachments]</a
                                                    >
                                                    <b-popover
                                                        :target="`viewFiles-${x.id}`"
                                                        triggers="click"
                                                        placement="right"
                                                        :show.sync="x.viewFile"
                                                        custom-class="popover-supplier"
                                                    >
                                                        <template v-slot:title>
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    align-items-center
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <small
                                                                    >Attachments</small
                                                                >
                                                                <span
                                                                    class="
                                                                        bx bx-x
                                                                        font-size-14
                                                                        cursor-pointer
                                                                    "
                                                                    @click="
                                                                        x.viewFile = false
                                                                    "
                                                                ></span>
                                                            </div>
                                                        </template>
                                                        <table
                                                            class="table table-bordered"
                                                            v-if="
                                                                !x.attachmentLoading &&
                                                                x.poFiles.length > 0
                                                            "
                                                        >
                                                            <thead>
                                                                <tr>
                                                                    <th>File Description</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr
                                                                    v-for="y in x.poFiles"
                                                                    :key="y.id"
                                                                >
                                                                    <td>
                                                                        <a
                                                                            href="javascript:void(0);"
                                                                            class="hoverable-link"
                                                                            @click="readFile(y.id)"
                                                                        >
                                                                            {{ y.description }}
                                                                        </a>
                                                                        <small class="d-block">Uploaded by {{y.uploadedBy}}</small>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <div
                                                            class="text-center"
                                                            v-if="
                                                                !x.attachmentLoading &&
                                                                x.poFiles.length == 0
                                                            "
                                                        >
                                                            No data found
                                                        </div>
                                                        <div
                                                            v-if="x.attachmentLoading"
                                                            class="text-center"
                                                        >
                                                            <b-spinner
                                                                variant="primary"
                                                                label="Loading..."
                                                            ></b-spinner>
                                                        </div>
                                                    </b-popover>
                                                </div>
                                                <div class="mt-3">
                                                    <button
                                                        type="button"
                                                        class="btn btn-purple me-1"
                                                        @click="printPO(x.id)"
                                                    >
                                                        <i
                                                            class="bx bx-printer me-1"
                                                        ></i
                                                        >Print P.O
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="col-md-7 border-start border-3">
                                                <div class="ms-2">
                                                    <div class="mb-2">
                                                        <b class="font-size-16"
                                                            >Supplier Offers:</b
                                                        >
                                                    </div>
                                                    <div>
                                                        <table width="100%">
                                                            <thead>
                                                                <tr
                                                                    class="
                                                                        border-bottom
                                                                    "
                                                                >
                                                                    <th
                                                                        style="
                                                                            width: 90px;
                                                                        "
                                                                        class="py-2"
                                                                    >
                                                                        Qty
                                                                    </th>
                                                                    <th class="py-2">
                                                                        Item Name
                                                                    </th>
                                                                    <th class="py-2" style="width: 150px;">
                                                                        Notes
                                                                    </th>
                                                                    <th
                                                                        class="py-2"
                                                                        style="width: 150px;"
                                                                    >
                                                                        Unit Price
                                                                    </th>
                                                                    <th
                                                                        class="py-2"
                                                                        style="width: 150px;"
                                                                    >
                                                                        Total Price
                                                                    </th>
                                                                    <th style="width:50px;"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr
                                                                    v-for="y in x.poItems"
                                                                    :key="y.id"
                                                                    class="
                                                                        border-bottom
                                                                    "
                                                                >
                                                                    <td class="py-2 px-2">
                                                                        <span>{{ y.quantity }}</span>
                                                                    </td>
                                                                    <td class="py-2">
                                                                        <div>
                                                                            {{
                                                                                y.itemName
                                                                            }}
                                                                        </div>
                                                                        <small>{{
                                                                            y.description
                                                                        }}</small>
                                                                    </td>
                                                                    <td class="py-2">
                                                                        <span>{{ y.prNote }}</span>
                                                                    </td>
                                                                    <td class="py-2">
                                                                        {{
                                                                            formatCurrency(
                                                                                y.unitCost
                                                                            )
                                                                        }}
                                                                    </td>
                                                                    <td class="py-2">
                                                                        {{
                                                                            formatCurrency(
                                                                                y.unitCost *
                                                                                    y.quantity
                                                                            )
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-else>
                                            <div class="col-md-4">
                                                <div class="px-2 py-2 bg-soft bg-info rounded-3 h-100">
                                                    <b class="font-size-15">Supplier Details:</b>
                                                    <div class="d-flex ms-3 mt-2">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Name: <span class="font-weight-bold text-info">{{ x.supplier}}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Address: <span class="font-weight-bold text-info">{{ x.address}}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14 break-word">
                                                            Contact No: <span class="font-weight-bold text-info ">{{ x.contactNumber }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Email: <span class="font-weight-bold text-info">{{ x.email }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            TIN: <span class="font-weight-bold text-info">{{ x.tin }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="px-2 py-2 bg-soft bg-purple rounded-3 h-100">
                                                    <b class="font-size-15">P.O Details:</b>
                                                    <div class="d-flex ms-3 mt-2">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            P.O Number: <span class="font-weight-bold text-primary">{{ x.poNumber }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            P.O Date: <span class="font-weight-bold text-primary">{{ formatDate(new Date(x.poDate)) }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Description: <span class="font-weight-bold text-primary">{{ x.poDescription }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Delivery Unit: <span class="font-weight-bold text-primary">{{ x.deliveryUnit }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Fund Source: <span class="font-weight-bold text-primary">{{ x.fundSource }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Fund Cluster: <span class="font-weight-bold text-primary">{{ x.fundCluster }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="px-2 py-2 bg-soft bg-success rounded-3 h-100">
                                                    <b class="font-size-15">Request For Payment Details:</b>
                                                    <div class="d-flex ms-3 mt-2 align-items-center">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Amount: <span class="font-weight-bold text-orange font-size-20">{{ formatCurrency(x.amount) }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3 align-items-center">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            RFP Number: <span class="font-weight-bold text-green">{{ x.poNumber }}</span>
                                                        </span>
                                                       
                                                    </div>
                                                    <div class="d-flex ms-3 align-items-center">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            RFP Date: <span class="font-weight-bold text-green">{{ formatDate(new Date(x.rfpDate)) }}</span>
                                                        </span>
                                                    </div>
                                                    <div class="d-flex ms-3">
                                                        <i class="me-2">-</i>
                                                        <span class="font-size-14">
                                                            Particulars: <span class="font-weight-bold text-green">{{ x.particulars }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </div>
                        <div class="row mb-2 mt-4" v-if="items.length">
                            <div class="col-md-12 text-right">
                                <ul
                                    class="pagination pagination-rounded mb-0 float-end"
                                >
                                    <!-- pagination -->
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="rows"
                                        :per-page="perPage"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>